import React, { useEffect, useState } from "react";

import {
  CButton,
  CCard,
  CCardHeader,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CNav,
  CNavItem,
  CNavLink,
  CSpinner,
  CTabs
} from "@coreui/react";
import { RiCheckDoubleFill } from "react-icons/ri";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../../actions/baseActions";
import { setObj } from "../../../../../actions/noteActions";
import Breadcrumb from "../../../../../components/Breadcrumb";
import Loading from "../../../../../components/Loading";
import ProtectedRoute from "../../../../../components/ProtectedRoute";
import URL from "../../../../../config/api";
import axios from "../../../../../config/axios";

const PartialProgressionAllocateByUser = props => {
  const [loading, setLoading] = useState(true);
  const [trails, setTrails] = useState([]);

  const [trailInAction, setTrailInAction] = useState();
  const [showModal, setShowModal] = useState(false);
  const [trailToDelete, setTrailToDelete] = useState();

  const userID = props.match.params.id;
  const [userName, setUserName] = useState();

  useEffect(() => {
    (async () => {
      try {
        const trailListResponse = await axios.get(
          `${URL.api}activity/trail/public?is_partial_progression=true`,
          {
            headers: { authorization: `Bearer ${props.user.token}` }
          }
        );
        const allocationListResponse = await axios.get(
          `${URL.api}activity/trail_allocation/partial_progression/listByUser/${userID}`,
          {
            headers: {
              Authorization: `Bearer ${props.user.token}`
            }
          }
        );
        const userResponse = await axios.get(
          `${URL.api}access/user/singleView/${userID}`,
          {
            headers: { Authorization: `Bearer ${props.user.token}` }
          }
        );

        const trailList = trailListResponse.data.data.map(trail => {
          let auxTrail = { ...trail, allocation_id: 0 };
          allocationListResponse.data.data.map(allocation => {
            if (allocation.trail_id === trail.id) {
              auxTrail.allocation_id = allocation.trail_allocation_id;
            }
          });
          return auxTrail;
        });

        setTrails(trailList);
        setUserName(userResponse.data.data.user?.name);
      } catch {
        toastr.error("Erro!", "Não foi possivel acessar dados necessários");
      }
      setLoading(false);
    })();
  }, []);

  const createAllocation = async trailId => {
    const allocationResponse = await axios.post(
      `${URL.api}activity/trail_allocation/partial_progression/insert`,
      {
        trail_id: trailId,
        user_id: userID,
        allocator_user_id: props.user.user.id
      },
      {
        headers: {
          Authorization: `Bearer ${props.user.token}`
        }
      }
    );
    const updatedTrailList = trails.map(trail => {
      let auxTrail = trail;
      if (trail.id === trailId) {
        auxTrail.allocation_id = allocationResponse.data.data;
      }
      return auxTrail;
    });
    setTrails(updatedTrailList);
    setTrailInAction(null);
  };

  const deleteAllocation = async () => {
    setTrailInAction(trailToDelete.id);
    await axios.delete(
      `${URL.api}activity/trail_allocation/partial_progression/delete/${trailToDelete.allocation_id}`,
      {
        headers: {
          authorization: `Bearer ${props.user.token}`
        }
      }
    );
    const updatedTrailList = trails.map(trail => {
      let auxTrail = trail;
      if (trail.id === trailToDelete.id) {
        auxTrail.allocation_id = 0;
      }
      return auxTrail;
    });
    setTrails(updatedTrailList);
    setTrailInAction(null);
    setShowModal(false);
  };

  return (
    <div>
      <CModal
        color="danger"
        show={showModal}
        centered
        onClose={() => setShowModal(false)}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>Apagar alocação</CModalHeader>
        <CModalBody>Deseja apagar a alocação?</CModalBody>
        <CModalFooter>
          <CButton color="danger" onClick={() => deleteAllocation()}>
            Confirmar
          </CButton>
          <CButton color="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>
      <Breadcrumb current={props.currentRoute} />
      {loading ? (
        <Loading top="45" left="50" />
      ) : (
        <>
          <h3 className="mb-4">
            Aloque trilha de progressão parcial para
            <strong> {userName}</strong>
          </h3>
          {trails.length > 0 ? (
            <>
              <CTabs>
                <CNav variant="tabs" className="d-flex mb-4">
                  <CNavItem>
                    <CNavLink className="tab-not-focus">
                      <h4 className="d-inline-block mr-1 mb-0 p-1">Trilhas</h4>
                    </CNavLink>
                  </CNavItem>
                </CNav>
              </CTabs>
              {trails.map(trail => (
                <CCard accentColor="primary mt-0 mb-2" key={trail.id}>
                  <CCardHeader className="d-flex align-items-center rounded border-0">
                    <h4 className="m-0 p-0 flex-1 d-flex align-items-center">
                      {trail.name}
                      {trail.allocation_id !== 0 && (
                        <RiCheckDoubleFill className="ml-2 text-success" />
                      )}
                    </h4>
                    <CButton
                      color={trail.allocation_id ? "danger" : "primary"}
                      className="d-flex justify-content-center align-items-center ml-2"
                      disabled={trailInAction === trail.id}
                      onClick={async () => {
                        if (trail.allocation_id) {
                          setTrailToDelete(trail);
                          setShowModal(true);
                        } else {
                          setTrailInAction(trail.id);
                          createAllocation(trail.id);
                        }
                      }}
                    >
                      <>
                        <span
                          style={
                            trailInAction === trail.id ? { opacity: 0 } : null
                          }
                        >
                          {trail.allocation_id ? "Cancelar" : "Alocar"}
                        </span>
                        {trailInAction === trail.id && (
                          <CSpinner
                            size="sm"
                            color="white"
                            style={{ position: "absolute" }}
                          />
                        )}
                      </>
                    </CButton>
                  </CCardHeader>
                </CCard>
              ))}
            </>
          ) : (
            <div className="p-5 text-center text-muted w-100">
              Nenhuma trilha encontrada
            </div>
          )}
        </>
      )}
      <ProtectedRoute routeId={props.currentRoute} />
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

PartialProgressionAllocateByUser.defaultProps = {
  hideLayout: false,
  guestLogin: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartialProgressionAllocateByUser);
